import React from "react";
import styles from "../styles/Main.module.scss";
import { AiOutlineMenu } from "react-icons/ai";
import { FaFacebook, FaTwitter, FaWhatsapp } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
function DemoOne() {
  const variants = {
    init: {
      opacity: 0,
    },
    anim: {
      opacity: 1,
      transition: {
        staggerChildren: 0.8,
      },
    },
  };
  const navItems = {
    init: {
      y: -300,
    },
    anim: {
      y: 0,
      transition: {
        duration: 0.2,
        type: "spring",
        stiffness: 50,
      },
    },
  };
  const variantSvg = {
    init: {
      opacity: 0,
    },
    anim: {
      opacity: 1,
      transition: {
        staggerChildren: 1,
      },
    },
  };
  const svgItems = {
    init: {
        opacity:0,
      y: -300,
    },
    anim: {
        opacity:1,
      y: 0,
      transition: {
        duration: 0.6,
        type: "spring",
        stiffness:190
      },
    },
  };
  return (
    <div className={styles.main_home_land}>
      <div className={styles.handle_navBar}>
        <motion.nav initial="init" animate="anim" variants={variants}>
          <motion.div variants={navItems}>
            <h2>LoGo</h2>
          </motion.div>
          <motion.ul>
            <motion.li variants={navItems}>
              <NavLink activeClassName="" to="/">
                iBrandup
              </NavLink>
            </motion.li>
            <motion.li variants={navItems}>About</motion.li>
            <motion.li variants={navItems}>Services</motion.li>
            <motion.li variants={navItems}>Contact</motion.li>
          </motion.ul>
          <motion.div variants={navItems}>
            <span>
              <AiOutlineMenu />
            </span>
          </motion.div>
        </motion.nav>
      </div>
      <div className={styles.handle_Svg}>
        <motion.svg
          width="765"
          height="306"
          viewBox="0 0 965 506"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          initial="init"
          animate="anim"
          variants={variantSvg}
        >
          <g clip-path="url(#clip0)">
            <motion.path
              variants={svgItems}
              d="M13.4006 262H79.2741C113.905 262 132.349 243.932 132.349 219.389C132.349 196.578 116.013 182.801 98.4716 181.973V180.467C114.507 176.854 126.327 165.486 126.327 147.342C126.327 124.23 109.162 107.818 75.1335 107.818H13.4006V262ZM45.9986 235.349V194.395H73.3267C88.9858 194.395 98.6974 203.429 98.6974 216.152C98.6974 227.746 90.7926 235.349 72.5739 235.349H45.9986ZM45.9986 172.337V134.168H70.7671C85.2216 134.168 93.4276 141.621 93.4276 152.763C93.4276 164.959 83.4901 172.337 70.1648 172.337H45.9986ZM162.176 263.161C176.884 263.161 186.793 256 189.116 244.969L173.865 243.962C172.201 248.491 167.943 250.852 162.447 250.852C154.202 250.852 148.976 245.395 148.976 236.531V236.492H189.464V231.963C189.464 211.758 177.233 201.771 161.518 201.771C144.022 201.771 132.681 214.196 132.681 232.544C132.681 251.394 143.867 263.161 162.176 263.161ZM148.976 226.273C149.325 219.499 154.473 214.08 161.789 214.08C168.949 214.08 173.904 219.19 173.943 226.273H148.976Z"
              fill="black"
            />
            <motion.path
              variants={svgItems}
              d="M300.252 144.445H349.188C348.228 97.0178 307.791 63.4346 248.027 63.4346C189.085 63.4346 144.81 96.6065 144.947 146.227C144.947 186.527 173.596 209.692 219.79 221.618L251.728 229.842C282.021 237.518 302.034 246.977 302.171 268.771C302.034 292.759 279.28 308.797 246.108 308.797C214.307 308.797 189.634 294.541 187.577 265.07H137.545C139.602 320.859 181.135 352.249 246.519 352.249C313.822 352.249 352.888 318.666 353.026 269.183C352.888 220.521 312.726 198.315 270.507 188.309L244.189 181.729C221.161 176.246 196.213 166.514 196.487 143.075C196.624 121.965 215.54 106.476 247.342 106.476C277.635 106.476 297.648 120.594 300.252 144.445Z"
              fill="black"
            />
            <motion.path
              variants={svgItems}
              d="M420.059 281.499C420.124 294.886 410.961 301.905 401.018 301.905C390.555 301.905 383.797 294.561 383.732 282.799V224.182H356.048V287.738C356.113 311.068 369.76 325.3 389.84 325.3C404.852 325.3 415.64 317.566 420.124 305.869H421.163V324H447.743V224.182H420.059V281.499ZM504.922 325.95C531.501 325.95 548.202 310.353 549.502 287.413H523.378C521.753 298.071 514.734 304.049 505.247 304.049C492.314 304.049 483.931 293.197 483.931 274.091C483.931 255.245 492.379 244.457 505.247 244.457C515.384 244.457 521.883 251.151 523.378 261.094H549.502C548.332 238.024 530.851 222.882 504.792 222.882C474.508 222.882 455.792 243.873 455.792 274.481C455.792 304.829 474.183 325.95 504.922 325.95ZM602.262 325.95C628.841 325.95 645.542 310.353 646.842 287.413H620.718C619.093 298.071 612.075 304.049 602.587 304.049C589.655 304.049 581.271 293.197 581.271 274.091C581.271 255.245 589.72 244.457 602.587 244.457C612.725 244.457 619.223 251.151 620.718 261.094H646.842C645.672 238.024 628.191 222.882 602.132 222.882C571.849 222.882 553.133 243.873 553.133 274.481C553.133 304.829 571.524 325.95 602.262 325.95ZM699.992 325.95C724.687 325.95 741.323 313.927 745.222 295.406L719.618 293.717C716.823 301.32 709.675 305.284 700.447 305.284C686.605 305.284 677.832 296.121 677.832 281.239V281.174H745.807V273.571C745.807 239.648 725.272 222.882 698.887 222.882C669.514 222.882 650.473 243.743 650.473 274.546C650.473 306.194 669.254 325.95 699.992 325.95ZM677.832 264.018C678.417 252.646 687.06 243.548 699.342 243.548C711.365 243.548 719.683 252.126 719.748 264.018H677.832ZM799.298 325.95C823.993 325.95 840.629 313.927 844.528 295.406L818.924 293.717C816.129 301.32 808.981 305.284 799.753 305.284C785.911 305.284 777.138 296.121 777.138 281.239V281.174H845.113V273.571C845.113 239.648 824.578 222.882 798.193 222.882C768.82 222.882 749.779 243.743 749.779 274.546C749.779 306.194 768.56 325.95 799.298 325.95ZM777.138 264.018C777.723 252.646 786.366 243.548 798.648 243.548C810.671 243.548 818.989 252.126 819.054 264.018H777.138ZM889.896 325.625C906.013 325.625 914.396 316.332 918.23 308.013H919.4V324H946.694V190.909H919.075V240.948H918.23C914.526 232.825 906.533 222.882 889.831 222.882C867.931 222.882 849.41 239.908 849.41 274.221C849.41 307.624 867.151 325.625 889.896 325.625ZM898.669 303.594C885.087 303.594 877.679 291.507 877.679 274.091C877.679 256.805 884.957 244.912 898.669 244.912C912.121 244.912 919.66 256.285 919.66 274.091C919.66 291.897 911.991 303.594 898.669 303.594Z"
              fill="black"
            />
            <motion.path
              variants={svgItems}
              d="M430.726 377.182H410.905V370.488C410.905 363.73 413.635 359.766 421.758 359.766C425.072 359.766 428.451 360.48 430.661 361.195L435.535 340.4C432.091 339.36 424.487 337.67 415.974 337.67C397.193 337.67 383.221 348.263 383.221 369.968V377.182H369.119V397.977H383.221V477H410.905V397.977H430.726V377.182ZM479.099 478.95C509.383 478.95 528.229 458.219 528.229 427.481C528.229 396.548 509.383 375.882 479.099 375.882C448.816 375.882 429.97 396.548 429.97 427.481C429.97 458.219 448.816 478.95 479.099 478.95ZM479.229 457.504C465.257 457.504 458.109 444.702 458.109 427.286C458.109 409.87 465.257 397.002 479.229 397.002C492.941 397.002 500.09 409.87 500.09 427.286C500.09 444.702 492.941 457.504 479.229 457.504ZM536.165 477H563.849V420.527C563.849 408.245 572.817 399.797 585.034 399.797C588.868 399.797 594.132 400.447 596.731 401.292V376.727C594.262 376.142 590.818 375.752 588.023 375.752C576.846 375.752 567.683 382.251 564.044 394.598H563.004V377.182H536.165V477ZM641.823 478.95C666.518 478.95 683.154 466.927 687.053 448.406L661.449 446.717C658.654 454.32 651.506 458.284 642.278 458.284C628.436 458.284 619.663 449.121 619.663 434.239V434.174H687.638V426.571C687.638 392.648 667.103 375.882 640.718 375.882C611.345 375.882 592.304 396.743 592.304 427.546C592.304 459.194 611.085 478.95 641.823 478.95ZM619.663 417.018C620.248 405.646 628.891 396.548 641.173 396.548C653.196 396.548 661.514 405.126 661.579 417.018H619.663ZM785.839 377.182H756.531L735.865 448.601H734.826L714.095 377.182H684.851L719.749 477H750.942L785.839 377.182ZM832.036 478.95C856.73 478.95 873.367 466.927 877.266 448.406L851.662 446.717C848.867 454.32 841.719 458.284 832.491 458.284C818.649 458.284 809.876 449.121 809.876 434.239V434.174H877.851V426.571C877.851 392.648 857.315 375.882 830.931 375.882C801.558 375.882 782.517 396.743 782.517 427.546C782.517 459.194 801.298 478.95 832.036 478.95ZM809.876 417.018C810.461 405.646 819.104 396.548 831.386 396.548C843.408 396.548 851.727 405.126 851.792 417.018H809.876ZM885.852 477H913.536V420.527C913.536 408.245 922.504 399.797 934.721 399.797C938.555 399.797 943.819 400.447 946.419 401.292V376.727C943.949 376.142 940.505 375.752 937.711 375.752C926.533 375.752 917.37 382.251 913.731 394.598H912.691V377.182H885.852V477Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="965" height="506" fill="white" />
            </clipPath>
          </defs>
        </motion.svg>
      </div>
      <div className={styles.land_content}>
        <p>
          We provide a full range of digital strategy <br />
          services, from market research and analytics <br />
          to useranalysis and conversion rate optimization <br />
          designed to take your online marketing to <strong>succeed</strong>
        </p>
      </div>
      <div className={styles.social_btns}>
        <div className={styles.social_btns_child}>
          <div className={styles.social_mediaIcons}>
            <div>
              <span className={styles.span_icons}>
                <FaFacebook />
              </span>
            </div>
            <div className={styles.span_icons}>
              <span>
                <FaWhatsapp />
              </span>
            </div>
            <div className={styles.span_icons}>
              <span>
                <FaTwitter />
              </span>
            </div>
          </div>
          <div>
            <button>Discover More ...</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DemoOne;
